import { onMounted, onUnmounted, ref } from "vue";

interface AnchorProps {
  id: string;
  title: string;
  icon: string;
}

export function useAnchor(anchorList: AnchorProps[]) {
  const curAnchorID = ref("");
  const anchorElementList = ref<HTMLElement[]>([]);
  // 高亮的视口范围
  const range = [0, 300];

  const handleScroll = () => {
    for (let index = 0; index < anchorElementList.value.length; index++) {
      const anchorElement = anchorElementList.value[index];
      const anchorElementTop = anchorElement.getBoundingClientRect().top;
      if (anchorElementTop >= range[0] && anchorElementTop <= range[1]) {
        curAnchorID.value = anchorElement.id;
        break;
      }
      if (
        anchorElementTop < range[0] &&
        anchorElementList.value[index + 1] &&
        anchorElementList.value[index + 1].getBoundingClientRect().top >= document.documentElement.clientHeight
      ) {
        curAnchorID.value = anchorElement.id;
        break;
      }
    }
  };

  onMounted(() => {
    anchorElementList.value = anchorList.map((anchor) => document.getElementById(anchor.id) as HTMLElement);
    window.addEventListener("scroll", handleScroll);
  });

  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
  });

  return {
    curAnchorID,
  };
}
